import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StatTileValueDirectionConstantType,
    StatTileValueNumberConstantType,
    StatTileValueDynamicStyleType,
    StatTileValueTextConstantType,
    StatTileValueDirection
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

export const STAT_TILE_VALUE_ROLLABLE_PATTERN = /^[\u0020-\u024F\u2000-\u206F\u20A0-\u20CF\u2212]+$/;

export const STAT_TILE_VALUE_DIGIT_PATTERN = /\d/;

export const STAT_TILE_VALUE_NON_DIGIT_PATTERN = /\D/g;

export const STAT_TILE_VALUE_NEGATIVE_PATTERN = /^\s*[^\d\s−-]{0,3}\s*[−-]/;

export const getStatTileValueText = ({
    children
}: StatTileValueTextConstantType): string | undefined => {
    if(typeof children !== "string" && typeof children !== "number") {
        return undefined;
    }

    const text = String(children);

    return STAT_TILE_VALUE_DIGIT_PATTERN.test(text) && STAT_TILE_VALUE_ROLLABLE_PATTERN.test(text) ? text : undefined;
};

export const getStatTileValueNumber = ({
    text
}: StatTileValueNumberConstantType): number => {
    const magnitude = Number(text.replace(STAT_TILE_VALUE_NON_DIGIT_PATTERN, ""));

    return STAT_TILE_VALUE_NEGATIVE_PATTERN.test(text) ? -magnitude : magnitude;
};

export const getStatTileValueDirection = ({
    previousText,
    currentText
}: StatTileValueDirectionConstantType): StatTileValueDirection => {
    if(previousText === undefined || currentText === undefined || previousText === currentText) {
        return 0;
    }

    const difference = getStatTileValueNumber({
        text: currentText
    }) - getStatTileValueNumber({
        text: previousText
    });

    if(!difference) {
        return 0;
    }

    return difference > 0 ? 1 : -1;
};

const stylesheet = StyleSheet.create({
    accessibleText: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    },
    container: {
        overflow: "hidden",
        minWidth: 0
    }
});

export const useStyles = ({
    borders
}: StatTileValueDynamicStyleType) => {
    const styles = {
        accessibleText: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
